export const easeExpo = [0.16, 1, 0.3, 1];

export const fadeUp = {
  initial: { y: 40, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: easeExpo },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 1.0, ease: easeExpo },
};

export const stagger = (delay = 0.08) => ({
  animate: { transition: { staggerChildren: delay } },
});

export const maskReveal = {
  initial: { y: "110%" },
  animate: { y: "0%" },
  transition: { duration: 1.1, ease: easeExpo },
};
